import { Paper, PaperProps, Popper, PopperPlacementType } from '@mui/material';
import { Editor } from '@tiptap/core';

export const CustomPopover = ({
  editor,
  clientRect,
  open = true,
  paperProps,
  children,
  placement = 'bottom-start',
}: {
  editor: Editor;
  clientRect?: (() => DOMRect | null) | null;
  open?: boolean;
  paperProps?: PaperProps;
  children: React.ReactNode;
  placement?: PopperPlacementType;
}) => (
  <Popper
    open={open}
    placement={placement}
    anchorEl={{
      getBoundingClientRect: () =>
        clientRect?.() || editor.view.dom.getBoundingClientRect(),
      nodeType: 1,
    }}
    sx={{ zIndex: 'modal' }}
  >
    <Paper {...paperProps} elevation={2}>
      {children}
    </Paper>
  </Popper>
);
